export interface KeyValue {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export type Theme = "sistema" | "claro" | "escuro";
export const themes: readonly Theme[] = ["sistema", "claro", "escuro"];

const keys = {
  theme: "nabla.tema",
} as const;

export interface Prefs {
  theme(): Theme;
  setTheme(theme: Theme): void;
}

export function createPrefs(storage: KeyValue | undefined): Prefs {
  const read = (key: string): string | null => {
    try {
      return storage?.getItem(key) ?? null;
    } catch {
      return null;
    }
  };
  const write = (key: string, value: string): void => {
    try {
      storage?.setItem(key, value);
    } catch {
    }
  };
  let theme: Theme = themes.find((known) => known === read(keys.theme)) ?? "sistema";
  return {
    theme: () => theme,
    setTheme(next) {
      theme = next;
      write(keys.theme, next);
    },
  };
}
